import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 8.4v7.2L12 18l-5-2.4V8.4L12 6l5 2.4zm-5-.182l3 1.44v4.684l-3 1.44-3-1.44V9.657l3-1.44z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 7.3a2 2 0 011.188-1.828l7-3.111a2 2 0 011.624 0l7 3.111A2 2 0 0121 7.3v9.4a2 2 0 01-1.188 1.828l-7 3.111a2 2 0 01-1.624 0l-7-3.111A2 2 0 013 16.7V7.3zm16 0v9.4l-7 3.111-7-3.11V7.3l7-3.111 7 3.11z"
      fill="currentColor"
    />
  </svg>
);
